export default __webpack_public_path__ + "static/media/kitchen3-afterD-1024w.8962b353.avif";